import { ICookieAccessToken } from '../../interfaces/src/auth.interface'
import { IAuthUser } from '../../interfaces/src/user.interface'
import { MACROBOLSA_ROLE } from '../constants/roles.constants'

export interface RolesByAuthUser {
  isIndependentAgent: boolean
  isBasicUser: boolean
  isAdminAgency: boolean
  isBrokerWithAgency: boolean
  isDeveloper: boolean
  isAdvance: boolean
  rolesExist: boolean
  userIsNotFree: boolean
  isNotAgency: boolean
  userIsFree: boolean
  userHasPlan: boolean
  isStarter: boolean
  isAssociation: boolean
}

export const rolesByAuthUser = (authUser: IAuthUser): RolesByAuthUser => {
  const roles = authUser?.roles

  const isAdminAgency = Boolean(roles?.AGENCY)

  const isAdvance = Boolean(roles?.ADVANCED)

  const isStarter = Boolean(roles?.STARTER)

  const isBasicUser = Boolean(
    roles?.BASIC && !roles?.BROKER && !roles?.AGENCY && !roles.AGENCY_BROKER
  )

  const isBrokerWithAgency = Boolean(
    roles?.BROKER && roles?.AGENCY_BROKER && !roles?.AGENCY
  )

  const isIndependentAgent = Boolean(roles?.BROKER && !roles?.AGENCY_BROKER)

  const isDeveloper = Boolean(
    !roles?.DEVELOPER_USER && (roles?.DEVELOPER || roles?.ROLE_ADMIN_DEVELOPER)
  )

  const rolesExist = Boolean(roles && Object.keys(roles)?.length > 0)

  const userIsNotFree = Boolean(
    rolesExist &&
      (roles?.PRIME || roles?.PRO || roles?.STARTER || roles?.ADVANCED)
  )

  const isNotAgency = Boolean(
    rolesExist && !roles?.AGENCY && !roles?.AGENCY_BROKER
  )

  const userIsFree = Boolean(
    rolesExist &&
      !roles?.PRIME &&
      !roles?.PRO &&
      !roles?.STARTER &&
      !roles?.ADVANCED
  )

  const userHasPlan = Boolean(
    rolesExist &&
      (roles?.PRIME || roles?.PRO || roles?.STARTER || roles?.ADVANCED)
  )

  const isAssociation = Boolean(rolesExist && roles.ASSOCIATION)

  return {
    isIndependentAgent,
    isBasicUser,
    isAdminAgency,
    isBrokerWithAgency,
    isDeveloper,
    isAdvance,
    rolesExist,
    userIsNotFree,
    isNotAgency,
    userIsFree,
    userHasPlan,
    isStarter,
    isAssociation
  }
}

export const getAuth0Roles = (
  accessTokenDecoded?: ICookieAccessToken | null
) => {
  const auth0Roles = accessTokenDecoded?.auth0Roles || []

  const hasMacrobolsaUser = auth0Roles?.includes(MACROBOLSA_ROLE)

  return {
    hasMacrobolsaUser,
    roles: auth0Roles
  }
}
